import React from "react";

const FooterItem = (props) => {
	const { text, href } = props;

	return (
		<a
			className="px-2 hover:text-primary-100 cursor-pointer transition-all"
			onClick={() => window.open(href, "_blank")}>
			{text}
		</a>
	);
};

export default FooterItem;
